<template>
  <div class="customer-page">
    <!-- Animated Background -->
    <div class="animated-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
    </div>

    <!-- Page Header -->
    <div class="page-header">
      <!-- <v-btn 
        icon 
        class="back-btn"
        to="/customer/data">
        <v-icon color="#222831">mdi-arrow-left</v-icon>
      </v-btn> -->
      <div class="header-content px-2">
        <div class="d-flex">
          <h1>Tambah Customer</h1>
          <div class="header-badge ml-2">
            <v-icon size="14" color="white">mdi-account-plus</v-icon>
            <span>Customer Baru</span>
          </div>
        </div>
        <p>Lengkapi informasi customer dengan data yang akurat</p>
      </div>
    </div>

    <ValidationObserver ref="form">
      <v-form @submit.prevent="save()">
        <!-- Modern Stepper -->
        <div class="stepper-wrapper">
          <div class="stepper-line">
            <div class="stepper-line-progress" :style="{ width: `${(currentStep / (steps.length - 1)) * 100}%` }"></div>
          </div>
          <div class="stepper-items">
            <div 
              v-for="(step, index) in steps" 
              :key="index"
              :class="['stepper-item', { 
                active: currentStep === index, 
                completed: currentStep > index 
              }]"
              @click="goToStep(index)">
              <div class="stepper-circle">
                <v-icon v-if="currentStep > index" size="16" color="white">mdi-check</v-icon>
                <span v-else>{{ index + 1 }}</span>
              </div>
              <div class="stepper-info">
                <!-- <span class="stepper-step">Step {{ index + 1 }}</span> -->
                <span class="stepper-title">{{ step.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Form Card -->
        <div class="main-card">
          <!-- Step 1: Data Diri -->
          <transition name="fade-slide" mode="out-in">
            <div v-if="currentStep === 0" key="step1" class="form-step">
              <div class="step-header">
                <div class="step-icon teal">
                  <v-icon color="white" size="28">mdi-account-circle-outline</v-icon>
                </div>
                <div>
                  <h2>Informasi Pribadi</h2>
                  <p>Data identitas dan informasi dasar customer</p>
                </div>
              </div>

              <div class="form-grid">
                <ValidationProvider name="Kode Sales" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-account-tie</v-icon></span>
                      Kode Sales
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.sales_region_id"
                      :items="sales"
                      item-value="id"
                      item-text="name"
                      placeholder="Pilih sales region"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-account</v-icon></span>
                      Nama Lengkap
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.name"
                      placeholder="Masukkan nama lengkap"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Nama Alias" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-badge-account-horizontal</v-icon></span>
                      Nama Alias
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.name_alias"
                      placeholder="Nama panggilan / alias"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="NIK" rules="required|min:16|max:16" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-card-account-details</v-icon></span>
                      NIK
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.nik"
                      placeholder="16 digit NIK"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Agama" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-hands-pray</v-icon></span>
                      Agama
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-select
                      v-model="form.religion"
                      :items="['Islam', 'Kristen', 'Katolik', 'Hindu', 'Buddha', 'Konghucu']"
                      placeholder="Pilih agama"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      clearable
                      :error-messages="errors">
                    </v-select>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="NPWP" rules="required|min:15|max:16" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-file-document</v-icon></span>
                      NPWP
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.npwp"
                      placeholder="Nomor NPWP"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </transition>

          <!-- Step 2: Kontak & Bisnis -->
          <transition name="fade-slide" mode="out-in">
            <div v-if="currentStep === 1" key="step2" class="form-step">
              <div class="step-header">
                <div class="step-icon coral">
                  <v-icon color="white" size="28">mdi-phone-message-outline</v-icon>
                </div>
                <div>
                  <h2>Kontak & Bisnis</h2>
                  <p>Informasi kontak dan data bisnis customer</p>
                </div>
              </div>

              <div class="form-grid">
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-email-outline</v-icon></span>
                      Email
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.email"
                      placeholder="email@contoh.com"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="email"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="No. Phone 1" :rules="{ required: true, regex: /^08[0-9]{8,11}$/ }" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-phone</v-icon></span>
                      No. Phone 1
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.mobilephone_array[0]"
                      placeholder="08xxxxxxxxxx"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="No. Phone 2" :rules="{ regex: /^08[0-9]{8,11}$/ }" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-phone</v-icon></span>
                      No. Phone 2
                    </label>
                    <v-text-field
                      v-model="form.mobilephone_array[1]"
                      placeholder="08xxxxxxxxxx"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Whatsapp" :rules="{ required: true, regex: /^08[0-9]{8,11}$/ }" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-whatsapp</v-icon></span>
                      Whatsapp
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.mobilephone_array[2]"
                      placeholder="08xxxxxxxxxx"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Plafon" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-cash-multiple</v-icon></span>
                      Plafon
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-currency-field
                      v-model="form.plafon"
                      placeholder="Limit kredit"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      prefix="Rp "
                      :error-messages="errors">
                    </v-currency-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Faktur" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-receipt</v-icon></span>
                      Faktur
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.faktur"
                      placeholder="faktur"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Term" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-calendar-clock</v-icon></span>
                      Term (Hari)
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.term"
                      placeholder="Contoh: 30"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      suffix="hari"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </transition>

          <!-- Step 3: Alamat -->
          <transition name="fade-slide" mode="out-in">
            <div v-if="currentStep === 2" key="step3" class="form-step">
              <div class="step-header">
                <div class="step-icon orange">
                  <v-icon color="white" size="28">mdi-map-marker-radius-outline</v-icon>
                </div>
                <div>
                  <h2>Alamat</h2>
                  <p>Informasi alamat lengkap customer</p>
                </div>
              </div>

              <div class="form-grid">
                <ValidationProvider name="Provinsi" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-map</v-icon></span>
                      Provinsi
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.province_name"
                      :items="province"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih provinsi"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeProvince()"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kota/Kabupaten" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-city-variant-outline</v-icon></span>
                      Kota / Kabupaten
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.city_name"
                      :items="city"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kota"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeCity()"
                      :disabled="!form.province_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kecamatan" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-home-group</v-icon></span>
                      Kecamatan
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.subdistrict_name"
                      :items="subdistrict"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kecamatan"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeSub()"
                      :disabled="!form.city_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kelurahan" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-home-outline</v-icon></span>
                      Kelurahan
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.village_name"
                      :items="village"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kelurahan"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :disabled="!form.subdistrict_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Alamat" rules="required" v-slot="{ errors }">
                  <div class="form-field full-width">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-map-marker</v-icon></span>
                      Alamat Lengkap
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-textarea
                      v-model="form.address"
                      placeholder="Jl. Nama Jalan No. XX, RT/RW, Detail lainnya..."
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      rows="3"
                      :error-messages="errors">
                    </v-textarea>
                  </div>
                </ValidationProvider>

                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-magnify</v-icon></span>
                    Cari Lokasi di Peta
                  </label>
                  <div class="search-box">
                    <v-icon class="search-box-icon">mdi-map-search</v-icon>
                    <gmap-autocomplete
                      placeholder="Ketik alamat untuk mencari lokasi..."
                      class="search-box-input"
                      @place_changed="setPlace">
                    </gmap-autocomplete>
                  </div>
                </div>

                <div class="form-field full-width">
                  <div class="map-container">
                    <gmap-map
                      :center="center"
                      :zoom="15"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                      :clickable="true"
                      @click="updatePlace"
                      class="gmap-view">
                      <gmap-marker
                        :position="center"
                        :draggable="true"
                        @drag="updatePlace">
                      </gmap-marker>
                    </gmap-map>
                  </div>
                </div>

                <ValidationProvider name="Latitude" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-latitude</v-icon></span>
                      Latitude
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.latitude"
                      placeholder="-2.9198476"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      step="any"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Longitude" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-longitude</v-icon></span>
                      Longitude
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.longitude"
                      placeholder="104.645729"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      step="any"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </transition>

          <!-- Step 4: Data Toko -->
          <transition name="fade-slide" mode="out-in">
            <div v-if="currentStep === 3" key="step4" class="form-step">
              <div class="step-header">
                <div class="step-icon yellow">
                  <v-icon color="#222831" size="28">mdi-store</v-icon>
                </div>
                <div>
                  <h2>Data Toko</h2>
                  <p>Informasi toko customer</p>
                </div>
              </div>

              <div class="form-grid">
                <ValidationProvider name="Nama Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-store</v-icon></span>
                      Nama Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.store_name"
                      placeholder="Masukkan nama toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Tipe Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-tag</v-icon></span>
                      Tipe Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.store_type"
                      :items="store_type_list"
                      item-value="id"
                      item-text="name"
                      placeholder="Pilih tipe toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="PIC Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-account-tie</v-icon></span>
                      PIC Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.store_pic_name"
                      placeholder="Nama penanggung jawab toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="No. Telp PIC" :rules="{ required: true, regex: /^08[0-9]{8,11}$/ }" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-phone</v-icon></span>
                      No. Telp PIC
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.pic_mobilephone"
                      placeholder="08xxxxxxxxxx"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :error-messages="errors">
                    </v-text-field>
                    <div v-if="picPhoneError" class="phone-error">
                      <v-icon size="14" color="#EA5455">mdi-alert-circle</v-icon>
                      {{ picPhoneError }}
                    </div>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Catatan Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field full-width">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-note-text</v-icon></span>
                      Catatan Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-textarea
                      v-model="form.store_notes"
                      placeholder="Catatan tambahan tentang toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      rows="3"
                      :error-messages="errors">
                    </v-textarea>
                  </div>
                </ValidationProvider>

                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-image-multiple</v-icon></span>
                    Foto Toko
                    <span class="badge-required">Wajib</span>
                    <span class="badge-info">{{ form.store_images_array.length }} foto</span>
                  </label>
                  
                  <!-- Preview uploaded images -->
                  <div v-if="form.store_images_array.length > 0" class="image-gallery">
                    <div 
                      v-for="(img, idx) in form.store_images_array" 
                      :key="idx" 
                      class="gallery-item">
                      <v-img :src="img" cover height="100" class="gallery-img"></v-img>
                      <button type="button" class="gallery-remove" @click="removeStoreImage(idx)">
                        <v-icon size="16" color="white">mdi-close</v-icon>
                      </button>
                    </div>
                    
                    <!-- Add more button -->
                    <uploadfolder v-model="upload.store_images_array">
                      <div slot="activator" class="gallery-add">
                        <div v-if="!process.store_images_array">
                          <v-icon size="24" color="#00ADB5">mdi-plus</v-icon>
                          <span>Tambah</span>
                        </div>
                        <v-progress-circular v-else indeterminate color="#00ADB5" size="24"></v-progress-circular>
                      </div>
                    </uploadfolder>
                  </div>
                  
                  <!-- Empty state - upload first image -->
                  <uploadfolder v-else v-model="upload.store_images_array">
                    <div slot="activator" class="upload-box">
                      <div v-if="!process.store_images_array" class="upload-placeholder">
                        <div class="upload-icon-circle">
                          <v-icon size="28" color="#00ADB5">mdi-camera</v-icon>
                        </div>
                        <div class="upload-info">
                          <span class="upload-title">Klik untuk upload foto toko</span>
                          <span class="upload-subtitle">PNG, JPG • Max 2MB • Bisa lebih dari 1 foto</span>
                        </div>
                      </div>
                      
                      <div v-else class="upload-loading">
                        <v-progress-circular indeterminate color="#00ADB5" size="36"></v-progress-circular>
                        <span>Mengupload...</span>
                      </div>
                    </div>
                  </uploadfolder>
                </div>
              </div>
            </div>
          </transition>

          <!-- Step 5: Lokasi Toko -->
          <transition name="fade-slide" mode="out-in">
            <div v-if="currentStep === 4" key="step5" class="form-step">
              <div class="step-header">
                <div class="step-icon purple">
                  <v-icon color="white" size="28">mdi-crosshairs-gps</v-icon>
                </div>
                <div>
                  <h2>Lokasi Toko</h2>
                  <p>Alamat dan koordinat lokasi toko</p>
                </div>
              </div>

              <div class="form-grid">
                <ValidationProvider name="Provinsi Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-map</v-icon></span>
                      Provinsi Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.store_province_name"
                      :items="store_province"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih provinsi toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeStoreProvince()"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kota/Kabupaten Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-city-variant-outline</v-icon></span>
                      Kota/Kabupaten Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.store_city_name"
                      :items="store_city"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kota toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeStoreCity()"
                      :disabled="!form.store_province_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kecamatan Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-home-group</v-icon></span>
                      Kecamatan Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.store_subdistrict_name"
                      :items="store_subdistrict"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kecamatan toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      @change="changeStoreSub()"
                      :disabled="!form.store_city_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Kelurahan Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-home-outline</v-icon></span>
                      Kelurahan Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-autocomplete
                      v-model="form.store_village_name"
                      :items="store_village"
                      item-value="name"
                      item-text="name"
                      placeholder="Pilih kelurahan toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      :disabled="!form.store_subdistrict_name"
                      clearable
                      :error-messages="errors">
                    </v-autocomplete>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Alamat Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field full-width">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-map-marker</v-icon></span>
                      Alamat Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-textarea
                      v-model="form.store_address"
                      placeholder="Masukkan alamat lengkap toko"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      rows="3"
                      :error-messages="errors">
                    </v-textarea>
                  </div>
                </ValidationProvider>

                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-magnify</v-icon></span>
                    Cari Lokasi Toko di Peta
                  </label>
                  <div class="search-box">
                    <v-icon class="search-box-icon">mdi-map-search</v-icon>
                    <gmap-autocomplete
                      placeholder="Ketik alamat untuk mencari lokasi toko..."
                      class="search-box-input"
                      @place_changed="setStorePlace">
                    </gmap-autocomplete>
                  </div>
                </div>

                <div class="form-field full-width">
                  <div class="map-container">
                    <gmap-map
                      :center="store_center"
                      :zoom="15"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                      :clickable="true"
                      @click="updateStorePlace"
                      class="gmap-view">
                      <gmap-marker
                        :position="store_center"
                        :draggable="true"
                        @drag="updateStorePlace">
                      </gmap-marker>
                    </gmap-map>
                  </div>
                </div>

                <ValidationProvider name="Latitude Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-latitude</v-icon></span>
                      Latitude Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.store_latitude"
                      placeholder="-2.9198476"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      step="any"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <ValidationProvider name="Longitude Toko" rules="required" v-slot="{ errors }">
                  <div class="form-field">
                    <label>
                      <span class="field-icon"><v-icon size="16">mdi-longitude</v-icon></span>
                      Longitude Toko
                      <span class="badge-required">Wajib</span>
                    </label>
                    <v-text-field
                      v-model="form.store_longitude"
                      placeholder="104.645729"
                      solo
                      flat
                      dense
                      hide-details="auto"
                      class="elegant-input"
                      background-color="#f8f9fa"
                      type="number"
                      step="any"
                      :error-messages="errors">
                    </v-text-field>
                  </div>
                </ValidationProvider>

                <div class="form-field full-width">
                  <label>
                    <span class="field-icon"><v-icon size="16">mdi-draw</v-icon></span>
                    Tanda Tangan
                    <span class="badge-required">Wajib</span>
                  </label>
                  <uploadfolder v-model="upload.ttd">
                    <div slot="activator" class="upload-box">
                      <div v-if="!form.ttd && !process.ttd" class="upload-placeholder">
                        <div class="upload-icon-circle">
                          <v-icon size="28" color="#00ADB5">mdi-signature-freehand</v-icon>
                        </div>
                        <div class="upload-info">
                          <span class="upload-title">Klik untuk upload tanda tangan</span>
                          <span class="upload-subtitle">PNG, JPG • Max 2MB</span>
                        </div>
                      </div>
                      
                      <div v-if="process.ttd" class="upload-loading">
                        <v-progress-circular indeterminate color="#00ADB5" size="36"></v-progress-circular>
                        <span>Mengupload...</span>
                      </div>

                      <div v-if="form.ttd && !process.ttd" class="upload-preview">
                        <v-img :src="form.ttd" contain max-height="100"></v-img>
                        <div class="upload-overlay">
                          <v-icon color="white" size="20">mdi-refresh</v-icon>
                          <span>Ganti Tanda Tangan</span>
                        </div>
                      </div>
                    </div>
                  </uploadfolder>
                </div>
              </div>
            </div>
          </transition>

          <!-- Navigation Buttons -->
          <div class="form-nav">
            <button 
              v-if="currentStep > 0"
              type="button"
              class="btn btn-outline"
              @click="currentStep--">
              <!-- <v-icon size="18">mdi-chevron-left</v-icon> -->
              Sebelumnya
            </button>
            <div class="nav-spacer"></div>
            <button 
              v-if="currentStep < steps.length - 1"
              type="button"
              class="btn btn-primary"
              @click="nextStep()">
              Selanjutnya
              <!-- <v-icon size="18" color="#fff">mdi-chevron-right</v-icon> -->
            </button>
            <button 
              v-else
              type="button"
              class="btn btn-success"
              :disabled="process.form"
              @click="save()">
              <v-progress-circular v-if="process.form" indeterminate size="18" width="2" color="white"></v-progress-circular>
              <v-icon v-else size="18">mdi-check-circle</v-icon>
              Simpan Customer
            </button>
          </div>
        </div>

        <!-- Error Alert -->
        <v-slide-y-transition>
          <div v-if="message.error" class="error-toast">
            <v-icon color="white" size="20">mdi-alert-circle</v-icon>
            <span>{{ message.error }}</span>
            <button type="button" @click="message.error = ''">
              <v-icon color="white" size="16">mdi-close</v-icon>
            </button>
          </div>
        </v-slide-y-transition>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { get, post } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  
  export default {
    data () {
      return {
        currentStep: 0,
        steps: [
          { title: 'Data Diri' },
          { title: 'Kontak' },
          { title: 'Alamat' },
          { title: 'Data Toko' },
          { title: 'Lokasi Toko' }
        ],
        form: {
          id: '',
          sales_region_id: '',
          name: '',
          name_alias: '',
          nik: '',
          religion: '',
          npwp: '',
          plafon: 0,
          faktur: '',
          email: '',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_name: '',
          address: '',
          latitude: '-2.9198476',
          longitude: '104.645729',
          mobilephone_array: ['', '', ''],
          term: '',
          ttd: '',
          // Store fields
          store_name: '',
          store_type: '',
          store_pic_name: '',
          pic_mobilephone: '',
          store_province_name: '',
          store_city_name: '',
          store_subdistrict_name: '',
          store_village_name: '',
          store_address: '',
          store_latitude: '-2.9198476',
          store_longitude: '104.645729',
          store_images_array: [],
          store_notes: '',
        },
        menu2: false,
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        sales: [],
        store_type_list: [
          { id: 'retail', name: 'Retail' },
          { id: 'grosir', name: 'Grosir' },
          { id: 'distributor', name: 'Distributor' },
          { id: 'agen', name: 'Agen' },
        ],
        store_province: [],
        store_city: [],
        store_subdistrict: [],
        store_village: [],
        center: {
          lat: -2.9198476, 
          lng: 104.645729
        },
        store_center: {
          lat: -2.9198476, 
          lng: 104.645729
        },
        upload: {
          ttd: null,
          store_images_array: null
        },
        process: {
          form: false,
          ttd: false,
          store_images_array: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ttd': {
        handler: function () {
          if (this.upload.ttd) {
            this.process.ttd = this.upload.ttd.process
            if (!this.process.ttd) {
              this.form.ttd = this.upload.ttd.fileuri
            }
          }
        },
        deep: true
      },
      'upload.store_images_array': {
        handler: function () {
          if (this.upload.store_images_array) {
            this.process.store_images_array = this.upload.store_images_array.process
            if (!this.process.store_images_array && this.upload.store_images_array.fileuri) {
              // Push to array instead of replacing
              this.form.store_images_array.push(this.upload.store_images_array.fileuri)
              // Reset upload for next image
              this.upload.store_images_array = null
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      set_color () {
        return this.$store.state.color
      },
      picPhoneError () {
        if (!this.form.pic_mobilephone) return ''
        if (!this.form.pic_mobilephone.startsWith('08')) {
          return 'Nomor harus diawali dengan 08'
        }
        if (this.form.pic_mobilephone.length < 10 || this.form.pic_mobilephone.length > 13) {
          return 'Nomor harus 10-13 digit'
        }
        if (!/^[0-9]+$/.test(this.form.pic_mobilephone)) {
          return 'Nomor hanya boleh berisi angka'
        }
        return ''
      },
      // Define which fields belong to which step for validation (only required fields)
      stepFields () {
        return {
          0: ['Nama', 'Nama Alias', 'NIK', 'NPWP'],
          1: ['Email', 'Plafon', 'Faktur', 'Ketentuan'],
          2: ['Provinsi', 'Kota/Kabupaten', 'Kecamatan', 'Kelurahan', 'Alamat'],
          3: ['Nama Toko', 'Tipe Toko', 'PIC Toko'],
          4: ['Alamat Toko']
        }
      }
    },
    mounted () {
      this.fetchSales()
      this.fetchProv()
      this.fetchStoreProv()
    },
    methods: {
      async goToStep (index) {
        // Allow going backwards without validation
        if (index < this.currentStep) {
          this.currentStep = index
          return
        }
        
        // For forward navigation, validate current step first
        if (index > this.currentStep) {
          const isValid = await this.validateCurrentStep()
          if (isValid) {
            this.currentStep = index
          }
        }
      },
      
      async validateCurrentStep () {
        // Validate with VeeValidate - only mounted fields (current step) will be validated
        const observer = this.$refs.form
        const isValid = await observer.validate()
        
        // If not valid, show error with field names
        if (!isValid) {
          const errors = observer.errors
          let errorFields = []
          
          // Collect all field names that have errors
          for (const key in errors) {
            if (errors[key] && errors[key].length > 0) {
              errorFields.push(key)
            }
          }
          
          if (errorFields.length > 0) {
            this.message.error = `${errorFields.join(', ')} wajib diisi`
            setTimeout(() => { this.message.error = '' }, 4000)
            return false
          }
        }
        
        return true
      },
      
      async nextStep () {
        const isValid = await this.validateCurrentStep()
        if (isValid) {
          this.currentStep++
        }
      },
      
      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        }
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },

      setStorePlace(place) {
        this.store_center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        this.form.store_latitude = place.geometry.location.lat()
        this.form.store_longitude = place.geometry.location.lng()
        // Auto-fill store address from searched location
        if (place.formatted_address) {
          this.form.store_address = place.formatted_address
        }
      },

      updateStorePlace(event) {
        this.store_center = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        }
        this.form.store_latitude = event.latLng.lat()
        this.form.store_longitude = event.latLng.lng()
      },

      async fetchProv() {
        let params = { limit: 10000000000000 }
        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.name === this.form.province_name) {
            id = obj.id
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {
        let params = {
          limit: 10000000000000,
          province_id: id
        }
        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      changeCity() {
        this.form.subdistrict_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.name === this.form.city_name) {
            id = obj.id
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {
        let params = {
          limit: 10000000000000,
          city_id: id
        }
        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.name === this.form.subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchVil(id)
      },

      async fetchVil(id) {
        let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }
        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },

      // Store location methods
      async fetchStoreProv() {
        let params = { limit: 10000000000000 }
        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.store_province = res.results.data
          }
        })
      },

      changeStoreProvince() {
        this.form.store_city_name = ''
        this.form.store_subdistrict_name = ''
        this.form.store_village_name = ''
        let id = ''
        this.store_province.map(obj => {
          if (obj.name === this.form.store_province_name) {
            id = obj.id
          }
        })
        this.fetchStoreCity(id)
      },

      async fetchStoreCity(id) {
        let params = {
          limit: 10000000000000,
          province_id: id
        }
        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.store_city = res.results.data
          }
        })
      },

      changeStoreCity() {
        this.form.store_subdistrict_name = ''
        this.form.store_village_name = ''
        let id = ''
        this.store_city.map(obj => {
          if (obj.name === this.form.store_city_name) {
            id = obj.id
          }
        })
        this.fetchStoreSub(id)
      },

      async fetchStoreSub(id) {
        let params = {
          limit: 10000000000000,
          city_id: id
        }
        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.store_subdistrict = res.results.data
          }
        })
      },

      changeStoreSub() {
        this.form.store_village_name = ''
        let id = ''
        this.store_subdistrict.map(obj => {
          if (obj.name === this.form.store_subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchStoreVil(id)
      },

      async fetchStoreVil(id) {
        let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }
        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.store_village = res.results.data
          }
        })
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }
        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      async fetchSales() {
        let params = { limit: 10000000000000 }
        await get(`admin/sales_region/data`, { params })
        .then(response => {
          let res = response.data
          if (res.status === 200) {
            this.sales = res.results.data
          }
        })
      },

      removeStoreImage (index) {
        this.form.store_images_array.splice(index, 1)
      },

      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        // console.log(this.form)
        
        if (isValid) {
          // Filter out empty phone numbers
          const filteredPhones = this.form.mobilephone_array.filter(phone => phone && phone.trim() !== '')
          let form = {
            ...this.form
            // mobilephone_array: JSON.stringify(filteredPhones),
            // store_images: JSON.stringify(this.form.store_images)
          }
          this.process.form = true

          await post(`admin/customer/add`, { data: form })
          .then((response) => {
            let res = response.data
            this.process.form = false

            if (res.status === 200) {
              this.$router.push({ path: '/customer/proses' })
            } else {
              this.message.error = res.message
            }
          })
        } else {
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            if (errors.length > 0) {
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 10)
        }
      }
    }
  }
</script>

<style scoped>
/* Color Hunt Palette - https://colorhunt.co/palettes/popular */
/* #222831 - Dark Navy */
/* #393E46 - Dark Gray */
/* #00ADB5 - Teal (Primary) */
/* #EEEEEE - Light Gray */
/* #EA5455 - Coral Red */
/* #F07B3F - Orange */
/* #FFD460 - Yellow */

/* Page Container */
.customer-page {
  position: relative;
  padding: 18px !important;
  padding-top: 36px !important;
  min-height: 100%;
  /* padding: 12px; */
  background: linear-gradient(180deg, #fcfcfc 0%, #f8fafa 100%);
}

/* Animated Background */
.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

/* Page Header */
.page-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 28px;
}

.back-btn {
  background: white !important;
  box-shadow: 0 2px 12px rgba(34, 40, 49, 0.08) !important;
  border: 1px solid #EEEEEE !important;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  border-radius: 20px;
  margin-bottom: 8px;
}

.header-badge span {
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
  letter-spacing: -0.5px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

/* Stepper */
.stepper-wrapper {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  padding: 18px 22px;
  margin-bottom: 24px;
  box-shadow: 0 2px 20px rgba(34, 40, 49, 0.06);
  border: 1px solid rgba(238, 238, 238, 0.8);
}

.stepper-line {
  position: absolute;
  top: 40px;
  left: 80px;
  right: 80px;
  height: 3px;
  background: #EEEEEE;
  border-radius: 2px;
}

.stepper-line-progress {
  height: 100%;
  background: linear-gradient(90deg, #00ADB5 0%, #00ADB5 100%);
  border-radius: 2px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.stepper-items {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.stepper-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  z-index: 1;
}

.stepper-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: white;
  border: 3px solid #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #393E46;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stepper-item.active .stepper-circle {
  background: #00ADB5;
  border-color: #00ADB5;
  color: white;
  transform: scale(1.1);
  box-shadow: 0 4px 20px rgba(0, 173, 181, 0.4);
}

.stepper-item.completed .stepper-circle {
  background: #00ADB5;
  border-color: #00ADB5;
  color: white;
}

.stepper-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stepper-step {
  font-size: 10px;
  font-weight: 600;
  color: #393E46;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stepper-title {
  font-size: 13px;
  font-weight: 600;
  color: #222831;
}

.stepper-item.active .stepper-title {
  color: #00ADB5;
}

/* Main Card */
.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

/* Form Step */
.form-step {
  padding: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f8f9fa;
}

.step-icon {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.teal {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
}

.step-icon.coral {
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
}

.step-icon.orange {
  background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);
  box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3);
}

.step-icon.yellow {
  background: linear-gradient(135deg, #FFD460 0%, #FFD460 100%);
  box-shadow: 0 8px 20px rgba(255, 212, 96, 0.3);
}

.step-icon.purple {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.3);
}

.step-header h2 {
  font-size: 14px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.step-header p {
  font-size: 12px;
  color: #393E46;
  margin: 0;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-field.full-width {
  grid-column: span 2;
}

/* Form Field */
.form-field label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #222831;
  margin-bottom: 10px;
}

.field-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #f8f9fa;
  border-radius: 6px;
}

.field-icon .v-icon {
  color: #393E46 !important;
}

.badge-required {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  color: #EA5455;
  background: rgba(234, 84, 85, 0.1);
  padding: 3px 8px;
  border-radius: 4px;
}

.badge-optional {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  color: #393E46;
  background: #f8f9fa;
  padding: 3px 8px;
  border-radius: 4px;
}

/* Elegant Input - Modern Styling */
.elegant-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 44px !important;
  border: 1px solid #e8eaed !important;
  background: #fafbfc !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
}

.elegant-input >>> .v-input__slot:hover {
  border-color: #d0d5dd !important;
  background: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06) !important;
}

.elegant-input >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
  border-color: #00ADB5 !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.12), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.elegant-input >>> .v-text-field__slot input,
.elegant-input >>> .v-select__slot input,
.elegant-input >>> .v-text-field__slot textarea {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #222831 !important;
  caret-color: #00ADB5 !important;
}

.elegant-input >>> .v-text-field__slot input::placeholder,
.elegant-input >>> .v-select__slot input::placeholder,
.elegant-input >>> .v-text-field__slot textarea::placeholder {
  color: #9ca3af !important;
  font-weight: 400 !important;
}

.elegant-input >>> .v-input__append-inner,
.elegant-input >>> .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
}

.elegant-input >>> .v-input__append-inner .v-icon,
.elegant-input >>> .v-input__prepend-inner .v-icon {
  color: #9ca3af !important;
  font-size: 18px !important;
}

.elegant-input >>> .v-input--is-focused .v-input__append-inner .v-icon {
  color: #00ADB5 !important;
}

.elegant-input >>> .v-text-field__prefix {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 13px !important;
}

.elegant-input >>> .v-select__selections {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #222831 !important;
}

.elegant-input >>> .v-input--is-disabled .v-input__slot {
  background: #f3f4f6 !important;
  border-color: #e5e7eb !important;
  opacity: 0.7 !important;
}

/* Error State */
.elegant-input.error--text >>> .v-input__slot {
  border-color: #EA5455 !important;
  background: #fff !important;
}

.elegant-input.error--text >>> .v-input--is-focused .v-input__slot {
  box-shadow: 0 0 0 3px rgba(234, 84, 85, 0.12) !important;
}

/* Input with Button */
.input-with-btn {
  display: flex;
  gap: 10px;
}

.input-with-btn .elegant-input {
  flex: 1;
}

.add-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #00ADB5 0%, #009ba3 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 173, 181, 0.25);
}

.add-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 173, 181, 0.35);
  background: linear-gradient(135deg, #00bdc6 0%, #00ADB5 100%);
}

.add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Phone Error */
.phone-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12px;
  color: #EA5455;
  font-weight: 500;
}

/* Tags */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.modern-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #ffffff;
  border: 1.5px solid #e8eaed;
  border-radius: 8px;
  font-size: 12px;
  color: #222831;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.modern-tag:hover {
  border-color: #d0d5dd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

/* Image Gallery for multiple uploads */
.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.gallery-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gallery-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: rgba(234, 84, 85, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  opacity: 0;
}

.gallery-item:hover .gallery-remove {
  opacity: 1;
}

.gallery-remove:hover {
  background: #EA5455;
  transform: scale(1.1);
}

.gallery-add {
  width: 100px;
  height: 100px;
  border: 2px dashed #d0d5dd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafbfc;
}

.gallery-add:hover {
  border-color: #00ADB5;
  background: rgba(0, 173, 181, 0.05);
}

.gallery-add span {
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
}

.badge-info {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  color: #00ADB5;
  background: rgba(0, 173, 181, 0.1);
  padding: 3px 8px;
  border-radius: 4px;
}

.modern-tag .v-icon {
  color: #00ADB5 !important;
}

.tag-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background: #EEEEEE;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag-remove:hover {
  background: #EA5455;
}

.tag-remove:hover .v-icon {
  color: white !important;
}

/* Search Box */
.search-box {
  position: relative;
}

.search-box-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #393E46 !important;
  z-index: 1;
}

.search-box-input {
  width: 100%;
  height: 44px;
  padding: 0 16px 0 44px;
  background: #fafbfc;
  border: 1.5px solid #e8eaed;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #222831;
  outline: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.search-box-input:hover {
  border-color: #d0d5dd;
  background: #f5f6f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.search-box-input:focus {
  background: #ffffff;
  border-color: #00ADB5;
  box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.12), 0 1px 2px rgba(0, 0, 0, 0.05);
}

.search-box-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

/* Map */
.map-container {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(34, 40, 49, 0.1);
  border: 2px solid #EEEEEE;
}

.gmap-view {
  width: 100%;
  height: 280px;
}

/* Upload Box */
.upload-box {
  border: 1.5px dashed #d0d5dd;
  border-radius: 10px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fafbfc;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.upload-box:hover {
  border-color: #00ADB5;
  border-style: solid;
  background: rgba(0, 173, 181, 0.04);
  box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.08);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-icon-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: white;
  border: 2px solid #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-info {
  text-align: center;
}

.upload-title {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #222831;
  margin-bottom: 4px;
}

.upload-subtitle {
  font-size: 12px;
  color: #393E46;
}

.upload-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-loading span {
  font-size: 13px;
  color: #393E46;
}

.upload-preview {
  position: relative;
  width: 100%;
}

.upload-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 173, 181, 0.9) 0%, rgba(0, 173, 181, 0.9) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 12px;
}

.upload-overlay span {
  font-size: 12px;
  color: white;
  font-weight: 600;
}

.upload-box:hover .upload-overlay {
  opacity: 1;
}

/* Form Navigation */
.form-nav {
  display: flex;
  align-items: center;
  padding: 0px 32px;
  padding-bottom: 24px !important;
  background: transparent;
}

.nav-spacer {
  flex: 1;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-outline {
  background: white;
  color: #222831;
  border: 1px solid #EEEEEE;
}

.btn-outline:hover {
  background: #f8f9fa;
  border-color: #00ADB5;
  color: #00ADB5;
}

.btn-primary {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 173, 181, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 173, 181, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 173, 181, 0.3);
}

.btn-success:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 173, 181, 0.4);
}

.btn-success:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Error Toast */
.error-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: #EA5455;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(234, 84, 85, 0.3);
  z-index: 1000;
}

.error-toast span {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.error-toast button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: background 0.2s ease;
}

.error-toast button:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Transitions */
.fade-slide-enter-active {
  transition: all 0.3s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.2s ease-in;
}

.fade-slide-enter {
  transform: translateX(30px);
  opacity: 0;
}

.fade-slide-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}

/* Responsive */
@media (max-width: 960px) {
  .stepper-line {
    display: none;
  }
  
  .stepper-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
  
  .stepper-info {
    display: none;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .form-field.full-width {
    grid-column: span 1;
  }
}

@media (max-width: 600px) {
  .customer-page {
    padding: 16px;
  }
  
  .header-content h1 {
    font-size: 22px;
  }
  
  .form-step {
    padding: 18px;
  }
  
  .step-icon {
    width: 48px;
    height: 48px;
  }
  
  .step-header h2 {
    font-size: 18px;
  }
  
  .form-nav {
    padding: 16px 20px;
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .btn {
    flex: 1;
    justify-content: center;
  }
  
  .bg-shape {
    opacity: 0.3;
  }
}
</style>

